import { render, staticRenderFns } from "./ConfigurarOfertaProcessoSeletivo.vue?vue&type=template&id=f46f73c2&scoped=true&"
import script from "./ConfigurarOfertaProcessoSeletivo.vue?vue&type=script&lang=js&"
export * from "./ConfigurarOfertaProcessoSeletivo.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurarOfertaProcessoSeletivo.vue?vue&type=style&index=0&id=f46f73c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46f73c2",
  null
  
)

export default component.exports